import React from 'react';
import './style.css';
// import whoWeAreImg from '../../../assets/img/why-we-exist-creative.png';
import whoWeAreImg from "../../../assets/img/banner/WhatsApp Image 2025-06-18 at 16.29.25_1bd8c189.jpg"


const WhyWeExist = () => {
  return (
    <section className="why_we_exist_section section_padding why-we-exist-card-bg" style={{ marginTop: '5%', marginBottom: '5%' }}>
      <div className="container">
        <div className="row align-items-center justify-content-center">
          
          <div className="col-lg-6 col-md-12 order-2 order-lg-1" >
            <div className="why_we_exist_text_card">
              {/* <h2 className="why_we_exist_title">Who We Are</h2>
              <h5 className="why_we_exist_subtitle">Bringing Light & Love to Expectant Mothers</h5> */}
              <p className="why_we_exist_paragraph">
                In Nigeria, unwed motherhood is often met with profound cultural and religious stigma. Many women in this situation experience rejection from their families, struggle with poverty, and lack access to essential mental health services or sexual education. The isolation and fear that result from these circumstances can be overwhelming, sometimes leading to tragic outcomes such as abortion, child abandonment, or even maternal mortality.
              </p>
              <p className="why_we_exist_paragraph">
                At Cradle Care Foundation, we are deeply committed to changing this narrative. We believe that every life is sacred and that every woman deserves grace, compassion, and unwavering support. Our mission is rooted in the Gospel of Christ, through which we share a message of unconditional love, redemption, and hope. We strive to provide not only encouragement but also practical resources and a supportive community, empowering women to face their challenges with dignity and strength.
              </p>
              <p className="why_we_exist_paragraph">
                By standing alongside expectant mothers, we aim to foster an environment where they are valued, supported, and given the opportunity to thrive, regardless of their circumstances. Through our work, we hope to bring light and love to those who need it most, transforming lives and building a more compassionate society.
              </p>
            </div>
          </div>

          <div className="col-lg-6 col-md-12 mb-4 mb-lg-0 order-1 order-lg-2">
            <div className="why_we_exist_img_card">
              <img src={whoWeAreImg} alt="Who We Are" className="img-fluid rounded-4 why_we_exist_img" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyWeExist;
